// extracted by mini-css-extract-plugin
export var editInput = "_kg-0";
export var editInputCompact = "_kg-2";
export var editInputLarge = "_kg-1";
export var editInputSmall = "_kg-3";